import React from 'react';
import { SFlex } from 'components/ReferencePriceSection/ReferencePriceSection.styled';
import { Flex, InfoAlert, Text } from 'UI';

interface NoLongerAvailableInfoProps {
  header: string;
  text: string;
}

export const NoLongerAvailableInfo = ({ header, text }: NoLongerAvailableInfoProps) => {
  return (
    <Flex align="center" justify="flex-end">
      <InfoAlert
        size="lg"
        message={
          <SFlex direction="column">
            <Text type="base" bold>
              {header}
            </Text>
            <Text type="search_result">{text}</Text>
          </SFlex>
        }
      />
    </Flex>
  );
};
